export function queryWithoutCache(options) {
  return {
    ...options,
    gcTime: 0,
    staleTime: 0
  };
}
